<template lang="pug">
div(
    :class="{ disabled: disabled }"
    :style="styleCircle"
    class="tl-icon-status"
)
    tl-position(
        class="icon-image"
        x="center"
        y="center"
    )
        transition(
            appear
            mode="out-in"
            name="fade-slide-y-1"
        )
            i(
                v-if="!number"
                :key="icon"
                :class="'mi-' + icon"
                :style="styleIcon"
            )
            span(
                v-else
                :key="number"
                :style="styleIcon"
            ) {{ number }}
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    icon: String,
    color: String,
    size: [Number, String],
    number: [Number, String],
    outlined: Boolean,
    disabled: Boolean,
})

const injects = getInjects(props, inject)

const styleType = computed(() => (props.outlined ? 'outlined' : null))
const color = computed(() => props.color || injects.color?.value || 'tl-blue')
const icon = computed(() => props.icon || injects.icon?.value || 'close')
const number = computed(() => props.number || injects.number?.value)
const size = computed(() => parseInt(props.size, 10) || parseInt(injects.size?.value, 10) || 40)

const circleBackground = computed(() => {
    if (props.disabled) {
        return 'rgba(0,0,0,0.2)'
    }

    if (styleType.value === 'outlined') {
        return 'var(--color-white)'
    }
    return color.value ? `var(--color-${color.value}-tint-light)` : 'var(--color-white-tint-dark)'
})

const circleBorder = computed(() => {
    if (props.disabled) {
        return 'rgba(0,0,0,0.0) !important'
    }

    if (styleType.value === 'outlined') {
        return `1px solid var(--color-${color.value})`
    }
    return 'none'
})

const styleCircle = computed(() => {
    if (props.disabled) {
        return {
            backgroundColor: circleBackground.value,
            width: `${size.value}px`,
            height: `${size.value}px`,
            border: circleBorder.value,
            cursor: 'not-allowed',
        }
    }

    return {
        backgroundColor: circleBackground.value,
        width: `${size.value}px`,
        height: `${size.value}px`,
        border: circleBorder.value,
    }
})
const styleIcon = computed(() => {
    if (props.disabled) {
        return {
            color: 'rgba(0,0,0,0.5)',
            fontSize: `${size.value / 1.9}px`,
            cursor: 'not-allowed',
        }
    }

    return {
        color: color.value ? `var(--color-${color.value})` : 'var(--color-black)',
        fontSize: `${size.value / 1.9}px`,
    }
})

</script>

<style lang="sass" scoped>
.tl-icon-status
    display: inline-block
    border-radius: 50%
    position: relative
    overflow: hidden
    transition: var(--transition-default)
    cursor: pointer
    .icon-image
        width: 100%
        height: 100%
        i
            margin: 0px
            line-height: 1
            transition: var(--transition-default)

    &.disabled
        outline: rgba(0, 0, 0, 0)
        border-color: rgba(0,0,0,0.0) !important
        color: rgba(0,0,0,0.5)
        background-color: rgba(0,0,0,0.1)
        >div
            transform: scale(0.9)
</style>
